import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import classes from '@/components/SchedulePage/Timeline/PendingOrders/SortSwitcher/style.module.scss';
import { sortPendingOrders } from '@/store/ducks/schedule';

const SortSwitcher = ({ layout }) => {
  const [isOlderDateSorted, setIsOlderDateSorted] = useState(false);

  const dispatch = useDispatch();

  const handleSortPendingOrders = () => {
    dispatch(sortPendingOrders({ older: !isOlderDateSorted }));

    setIsOlderDateSorted(state => !state);
  };

  const sortTypeText = isOlderDateSorted ? 'Mais novas' : 'Mais antigas';

  return (
    <div className={`${classes.sortSwitcher} ${layout === 'map' ? classes.mapLayout : ''}`}>
      <h4>Vistorias disponíveis</h4>

      <button type="button" onClick={handleSortPendingOrders}>
        {sortTypeText} <div className={`${classes.arrowDown} ${isOlderDateSorted ? classes.rotateArrow : ''}`} />
      </button>
    </div>
  );
};

SortSwitcher.propTypes = {
  layout: PropTypes.oneOf(['timeline', 'map']),
};

SortSwitcher.defaultProps = {
  layout: 'timeline',
};

export default SortSwitcher;
